import { render, staticRenderFns } from "./EXProposalOverview.vue?vue&type=template&id=eab1a2fc"
import script from "./EXProposalOverview.vue?vue&type=script&lang=js"
export * from "./EXProposalOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports